// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Linkedin = function Linkedin(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M5.563 5.3v7.385H3.1V5.3zm.157-2.276a1.18 1.18 0 0 1-.376.909 1.4 1.4 0 0 1-1.01.365h-.016a1.345 1.345 0 0 1-.984-.365 1.221 1.221 0 0 1-.373-.909 1.2 1.2 0 0 1 .384-.913 1.4 1.4 0 0 1 1-.361 1.365 1.365 0 0 1 .991.361 1.242 1.242 0 0 1 .384.913zm8.689 5.432v4.233h-2.452v-3.95a2.157 2.157 0 0 0-.3-1.226 1.06 1.06 0 0 0-.943-.444 1.207 1.207 0 0 0-.786.257 1.584 1.584 0 0 0-.473.637 1.805 1.805 0 0 0-.082.6v4.121H6.92q.015-2.973.015-4.822t-.008-2.201L6.92 5.3h2.452v1.076h-.015a3.256 3.256 0 0 1 .305-.417 3.168 3.168 0 0 1 .421-.388 1.937 1.937 0 0 1 .648-.324 2.953 2.953 0 0 1 .853-.116 2.647 2.647 0 0 1 2.049.846 3.549 3.549 0 0 1 .775 2.478z' })
  );
};

Linkedin.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Linkedin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Linkedin.js
// module id = 1042
// module chunks = 1